let mixins = {
    data() {
        return {
            screenWidth: document.body.clientWidth,
            screenHeight: document.documentElement.clientHeight,
        }
    },
    methods: {
        loginTip() {
            sessionStorage.clear();
            this.$router.push({
                name: 'Home'
            })
            this.$message({
                message: '请先进行登录',
                type: 'warning',
                offset: 120
            });
        },
        statusPd(data) {
            if(data.code == -1) {
                sessionStorage.clear();
                this.$router.push({
                    path: '/Login'
                })
                this.$message({
                    message: '请先进行登录',
                    type: 'warning',
                    offset: 120
                });
            } else if (data.code == 0) {
                this.$message({
                    message: data.msg,
                    type: 'warning',
                    offset: 120
                });
            }
        }
    }
}
export default mixins;